// Copyright (c) 2019 Deere & Company

import React, {PropTypes} from 'react';
import LabeledString from '../../../../shared/components/labeled-string/index';
import Warranty from '@deere/cps-it.warranty-model-factory/lib/warranty';

const WarrantyCoverageItemRowJdProtect = props =>
    <div className='warranty-coverage-item-row-jd-protect'>
        {props.warranty.uptimeAssurance.amount > 0 &&
            <LabeledString
                className='uptime-assurance-coverage'
                data={`${props.warranty.uptimeAssurance.amount} ${props.warranty.uptimeAssurance.unit.value}`}
                label='UPTIME_ASSURANCE'
            />
        }
        {props.warranty.wearPartCoverage.amount > 0 &&
            <LabeledString
                className='wear-part-coverage'
                data={`${props.warranty.wearPartCoverage.amount} ${props.warranty.wearPartCoverage.unit.value}`}
                label='WEAR_PARTS_COVERAGE'
            />
        }
    </div>;

WarrantyCoverageItemRowJdProtect.displayName = 'WarrantyCoverageItemRowJdProtect';
WarrantyCoverageItemRowJdProtect.propTypes = {
    warranty: PropTypes.instanceOf(Warranty).isRequired
};

export default WarrantyCoverageItemRowJdProtect;



// WEBPACK FOOTER //
// ./src/product/details/components/warranty-coverage-panel/warranty-coverage-item-row-jd-protect.js